<table mat-table [dataSource]="fees" class="mat-elevation-z0">
  <!-- Type Column -->
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef> Type </th>
    <td mat-cell *matCellDef="let element"> {{element.type}} </td>
  </ng-container>

  <!-- Description Column -->
  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef> Description </th>
    <td mat-cell *matCellDef="let element"> {{element.description}} </td>
  </ng-container>

  <!-- Fees Column -->
  <ng-container matColumnDef="fees">
    <th mat-header-cell *matHeaderCellDef> Fees </th>
    <td mat-cell *matCellDef="let element"> {{element.fee}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="feesColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: feesColumns;"></tr>
</table>
